import { useEffect } from 'react';
import { useAttributionPolkMatchbackQueries } from './AttributionPolkMatchbackQueries';
import { useAttributionPageContext } from './useAttributionPage';
import { Performance } from '../types/CampaignPerformance';

const useAttributionPolkMatchback = (): void => {
    const {
        attributionCriteria,
        attributionDate,

        setPerformances,
        setPreviousPerformances,

        setIsFetchingPerformances,
        setIsFetchingPreviousPerformances,

        setAmcReachAndFrequencyList,
        setIsFetchingAmcReachAndFrequencyList,

        setPreviousAmcReachAndFrequencyList,
        setIsFetchingPreviousAmcReachAndFrequencyList,
    } = useAttributionPageContext();

    const {
        currentPerformanceQuery,
        previousPerformanceQuery,
        currentReachFrequencyQuery,
        previousReachFrequencyQuery,
    } = useAttributionPolkMatchbackQueries(attributionCriteria, attributionDate);

    const { data: rawCurrentPerformances = [], isFetching: isFetchingCurrentPerformances } = currentPerformanceQuery;
    const { data: rawPreviousPerformances = [], isFetching: isFetchingPreviousPerformances } = previousPerformanceQuery;

    const { data: currentReachFrequencies = [], isFetching: isFetchingCurrentAmcReachAndFrequencyList } =
        currentReachFrequencyQuery;
    const { data: previousReachFrequencies = [], isFetching: isFetchingPreviousAmcReachAndFrequencyList } =
        previousReachFrequencyQuery;

    // Setup: List of Campaign Performance

    useEffect(() => {
        setPerformances((rawCurrentPerformances || []).map((v) => v as unknown as Performance));
    }, [setPerformances, rawCurrentPerformances]);

    useEffect(() => {
        setPreviousPerformances((rawPreviousPerformances || []).map((v) => v as unknown as Performance));
    }, [setPreviousPerformances, rawPreviousPerformances]);

    useEffect(() => {
        setIsFetchingPerformances(isFetchingCurrentPerformances);
    }, [setIsFetchingPerformances, isFetchingCurrentPerformances]);

    useEffect(() => {
        setIsFetchingPreviousPerformances(isFetchingPreviousPerformances);
    }, [setIsFetchingPreviousPerformances, isFetchingPreviousPerformances]);

    // Setup: List of AMC Reach and Frequency

    useEffect(() => {
        setAmcReachAndFrequencyList(currentReachFrequencies);
    }, [setAmcReachAndFrequencyList, currentReachFrequencies]);

    useEffect(() => {
        setPreviousAmcReachAndFrequencyList(previousReachFrequencies);
    }, [setPreviousAmcReachAndFrequencyList, previousReachFrequencies]);

    useEffect(() => {
        setIsFetchingAmcReachAndFrequencyList(isFetchingCurrentAmcReachAndFrequencyList);
    }, [setIsFetchingAmcReachAndFrequencyList, isFetchingCurrentAmcReachAndFrequencyList]);

    useEffect(() => {
        setIsFetchingPreviousAmcReachAndFrequencyList(isFetchingPreviousAmcReachAndFrequencyList);
    }, [setIsFetchingPreviousAmcReachAndFrequencyList, isFetchingPreviousAmcReachAndFrequencyList]);
};

export { useAttributionPolkMatchback };
